import React from 'react'
import View from './view'

const VenueSingle = ({ ...props }) => {
    return <View {...props} />
}

export default VenueSingle
